// src/app/rum-init.ts
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

function toRegExps(items?: string[], flags = 'i'): RegExp[] {
  return (items ?? []).map(s => new RegExp(s, flags));
}

export function initRum(cfg: any): void {
  const httpTuple: any = ['http', {
    recordAllRequests: !!cfg.http?.recordAllRequests,
    addXRayTraceIdHeader: !!cfg.http?.addXRayTraceIdHeader,
    addTraceContextHeader: !!cfg.http?.addTraceContextHeader,
    urlsToInclude: toRegExps(cfg.http?.urlsToInclude),
    urlsToExclude: toRegExps(cfg.http?.urlsToExclude)
  }];

  const rumConfig: AwsRumConfig = {
    sessionSampleRate: cfg.sessionSampleRate ?? 1,
    endpoint: cfg.endpoint,
    telemetries: ['performance','errors', httpTuple],
    allowCookies: !!cfg.allowCookies,
    enableXRay: true,
    signing: !!cfg.signing
  };

  if (typeof window !== 'undefined') {
    new AwsRum(cfg.appMonitorId, '1.0.0', cfg.region, rumConfig);
  }
}